import { useActiveForecastsFilterCount } from '@/features/forecasts/hooks/use-forecasts-hub-filter';
import { useForecastsFilterStore } from '@/features/forecasts/hooks/use-forecasts-hub-filter';
import {
  HubFilter,
  HubFilterOption,
} from '@/shared/components/filter/hub-filter';

export const ForecastsHubFilter = () => {
  const filterStore = useForecastsFilterStore();

  return (
    <HubFilter
      {...filterStore}
      activeCount={() => useActiveForecastsFilterCount()}
      options={[HubFilterOption.PROJECT, HubFilterOption.SUBPROJECT].map(
        (option) => ({
          option,
          allowMultiple: false,
        }),
      )}
    />
  );
};
